<template>
  <v-dialog v-model="show" v-bind="$attrs" persistent fullscreen>
    <v-container fill-height>
      <v-layout row justify-center align-center>
        <v-progress-circular
          indeterminate
          :size="70"
          :width="7"
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data: () => ({}),
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.loading-dialog {
  background-color: #303030;
}
</style>
